// extracted by mini-css-extract-plugin
export var dropdownButton = "_4b-0";
export var fullWidthDropdownButton = "_4b-1";
export var icon = "_4b-3";
export var iconPlaceholder = "_4b-2";
export var menuItemRow = "_4b-9";
export var separator = "_4b-e";
export var shortcutContainer = "_4b-7";
export var shortcutContainerFilled = "_4b-8";
export var shortcutIconLg = "_4b-6";
export var shortcutIconMd = "_4b-5";
export var shortcutIconSm = "_4b-4";
export var submenuChevron = "_4b-d";
export var submenuDropdown = "_4b-a";
export var submenuTriggerRow = "_4b-b";
export var submenuTriggerRowOpen = "_4b-c";